// Setup global jQuery
window.jQuery = window.$ = require("jquery");

import Cookies from "js-cookie";
import CMP from "./modules/CookiebotCMP.class";
const project = require('../../settings');

const pardotAccountID = project.pardotAccountID;
let fonts = [];
let CMPisReady = false;
let cookiebotCMP;

function loadAllFonts() {
    if(cookiebotCMP.hasConsent("marketing")) {
        fonts.forEach((value, index, array) => {
            !function(d, l, s) {
                const e = d.createElement(l); e.rel = s;
                e.href = value;
                d.head.appendChild(e);
            }(document, "link", "stylesheet");
        });

        fonts = [];
    }
}

window.loadGoogleFont = function (fontURL) {
    fonts.push(fontURL);

    if(CMPisReady) {
        loadAllFonts()
    }
};

// DOM Ready
jQuery(function() {
    const $ = jQuery;
    window.jQuery = window.$ = $;

    const $body = $('body');
    const trackingDiv = document.getElementById("pi_tracking_opt_in_div");

    cookiebotCMP = new CMP($body, "CookiebotOnConsentReady");

    // Hide Pardot built-in CMP
    $body.prepend("<style> #pi_tracking_opt_in_div{display: none !important;} </style>");

    $(window).on(cookiebotCMP.events.consent.marketing, function() {
        if(pardotAccountID) {
            Cookies.set(`pi_opt_in${pardotAccountID}`, "true");
            Cookies.set(`pi_opt_in${pardotAccountID-1e3}`, "true");
        }

        loadAllFonts();
    });

    $(window).on(cookiebotCMP.events.denied.marketing, function() {
        if(pardotAccountID) {
            Cookies.set(`pi_opt_in${pardotAccountID}`, "false");
            Cookies.set(`pi_opt_in${pardotAccountID-1e3}`, "false");
        }

        if(trackingDiv && typeof window.piDisableTracking === "function") {
            window.piDisableTracking(trackingDiv);
        }
    });

    $(window).on(cookiebotCMP.events.ready, function() {
        CMPisReady = true;
        loadAllFonts();
    });
});